export default {
  selectMenu: {
    height: null,
  },
}
